export default {"src":"/_next/static/media/polygon.474fc27a.svg","height":30,"width":137};